<template>
  <div class="vac">
    <h2>Вакансии</h2>
    <div class="row row-cols-1 row-cols-md-2 g-2">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">
                    Монтажник лифтов
                </h5>
                <p class="card-text">
                    Кандидаты приглашаются на собеседование
                </p>
            </div>
            <img src="../assets/logo.jpg" class="card-img-top" alt="монтажник лифтов">
        </div>
    </div>
    <Button />
  </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
    components: {
        Button
    },
}
</script>

<style scoped>
.vac {
  width: 90%;
  margin: 8vh auto;
}
h2 {
  font-size: 2vw;
  margin-bottom: 3vh;
}
p {
  margin-top: 2vw;
  font-size: 1.1vw;
  text-align: justify;
}
.row {
    margin-top: 3vh;
}
.card {
    width: 20%;
    margin-right: 20px;
}
.card-title {
    font-size: 1.7vw;
}
.card-img-top {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
img {
    margin-bottom: 5px;
}

@media (max-width: 767px) {

    h2 {
        font-size: 23px;
    }
    p {
        font-size: 14px;
    }
    .card {
        width: 100%;
    }
    .card-title {
        font-size: 19px;
    }

}
</style>